import React, { useEffect, useRef, useState } from "react";
import bgImage from "./assets/servicepage/hero.jpg"; // Replace with your actual image path

const HeroServices = () => {
  const [visible, setVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          observer.disconnect(); // Only trigger once on reload
        }
      },
      { threshold: 0.3 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section
      ref={sectionRef}
      className="relative h-screen bg-cover bg-center flex items-center justify-center px-6 md:px-16 text-center"
      style={{ backgroundImage: `url(${bgImage})` }}
    >
      {/* Animations */}
      <style>{`
        @keyframes fadeInUp {
          0% { opacity: 0; transform: translateY(30px); }
          100% { opacity: 1; transform: translateY(0); }
        }
        .animate-fade-up {
          opacity: 0;
          animation: fadeInUp 0.9s ease-out forwards;
        }
      `}</style>

      {/* Overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-[#000B2E]/90 to-[#02044f]/90 z-0" />

      {/* Content */}
      <div className={`relative z-10 max-w-4xl ${visible ? "animate-fade-up" : "opacity-0"}`}>
        <h1 className="text-white text-[48px] md:text-[110px] font-bold leading-tight font-satoshi">
          What Big Blue <br />
          <span className="text-[#00B2FF] font-extrabold">Delivers</span>
        </h1>
        <p className="mt-6 text-white text-base md:text-2xl leading-relaxed font-inter max-w-6xl mx-auto">
          At Big Blue, delivery is about arranging every movement with intention, intelligence and control. 
          We connect continents through systems that think ahead and teams <br />
          <span className="font-bold">that never fall behind.</span>
        </p>
      </div>
    </section>
  );
};

export default HeroServices;
